import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { getDeletedParticipants, getParticipant, queryParticipants, triggerParticipantEventWithPreviousStatus, triggerWatchdog, updateParticipant } from '@wix/ambassador-asa-participant-v1-participant/http';
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { ParticipantsClientBase } from './ParticipantsClientBase';
export class ParticipantsClient extends HttpBaseClient(ParticipantsClientBase) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "getDeleteParticipantImpl", getDeletedParticipants);
    _defineProperty(this, "getParticipantImpl", getParticipant);
    _defineProperty(this, "queryParticipantsImpl", queryParticipants);
    _defineProperty(this, "updateParticipantImpl", updateParticipant);
    _defineProperty(this, "triggerWatchdogImpl", triggerWatchdog);
    _defineProperty(this, "triggerParticipantEventImpl", triggerParticipantEventWithPreviousStatus);
  }
}
//# sourceMappingURL=ParticipantsClientHttp.js.map